<template>
    <div class="tw-w-fit tw-block tw-mx-auto">
        <div
            class="loader tw-border-solid tw-border-16 tw-border-t-16 tw-rounded-full tw-mx-auto tw-w-5 tw-h-5"
            :style="{ borderWidth: borderWidth + 'px', width: size + 'px', height: size + 'px' }"
        ></div>
    </div>
</template>
<script>
export default {
    name: 'Loader',
    props: {
        borderWidth: {
            type: Number,
            required: true,
            default: 4,
        },
        size: {
            type: Number,
            required: true,
            default: 20,
        },
    },
};
</script>
<style scoped lang="scss">
.loader {
    @apply tw-border-solid tw-border-dark-green tw-border-t-green;
    border-radius: 50%;
    margin: 0 auto;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
